import { ConnectProto } from "@racoon/api";

export const REORDERABLE_ROUTE_STATUS: ConnectProto.RouteStatus[] = [
  ConnectProto.RouteStatus.CREATED,
  ConnectProto.RouteStatus.IN_PROGRESS,
  ConnectProto.RouteStatus.NOT_APPROVED,
];
export const SELECTION_DISABLED_ROUTE_STATUSES: ConnectProto.RouteStatus[] = [
  ConnectProto.RouteStatus.CANCELLED,
  ConnectProto.RouteStatus.COMPLETED,
  ConnectProto.RouteStatus.FORCE_COMPLETED,
];
export const REORDERABLE_JOB_STATUSES: ConnectProto.JobStatus[] = [
  ConnectProto.JobStatus.ASSIGNED,
  ConnectProto.JobStatus.CREATED,
];

/** What the sidebar lists: trucks grouped by type, or drivers grouped by team. */
export type SidebarMode = "trucks" | "drivers";
/** A truck or a driver with that day's shifts; `id` is the truck id or the driver id. */
export type SidebarItem = {
  id: bigint;
  label: string;
  shifts: ConnectProto.DriverOnShift[];
  /** Jobs in ASSIGNED status across the day's routes of these shifts. */
  assignedJobs: number;
};
/** No label: drivers of an organization without teams, listed without a heading. */
export type SidebarSection = { key: string; label?: string; items: SidebarItem[] };
